module.exports = __webpack_public_path__ + "img/CameraRollOutlined.99996107.svg";